import { render, staticRenderFns } from "./PageModuleBuilder.vue?vue&type=template&id=6b3256ee&"
import script from "./PageModuleBuilder.vue?vue&type=script&lang=js&"
export * from "./PageModuleBuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports